var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.78 1.857a2.07 2.07 0 0 1 2.929 0l1.434 1.433c.809.809.809 2.12 0 2.929L7.09 13.272c-.5.5-1.143.83-1.84.946l-3.127.522a.75.75 0 0 1-.864-.863l.522-3.128c.116-.697.448-1.34.947-1.84zM3.79 9.97a1.9 1.9 0 0 0-.529 1.026l-.348 2.091 2.092-.348.144-.03c.333-.082.638-.254.882-.498l5.227-5.227-2.242-2.242zm7.86-7.053a.57.57 0 0 0-.808 0l-.765.765 2.241 2.241.766-.765a.57.57 0 0 0 0-.806z",
    clipRule: "evenodd"
  })));
};
export default Svg16;